import React from "react";

import { Form } from "@/components/ui/form";
import { cn } from "@/components/ui/utils";
import { LookupCacheProvider } from "@/lib/cache";
import { FormInfoProvider } from "../form/common";
import {
  type AccessionFormProps,
  AccessionFormProvider,
  useAccessionForm,
} from "./AccessionFormProvider";

export function AccessionForm(props: AccessionFormProps) {
  return (
    <LookupCacheProvider>
      <FormInfoProvider>
        <AccessionFormProvider {...props}>
          <AccessionFormInner {...props} ref={props.ref} />
        </AccessionFormProvider>
      </FormInfoProvider>
    </LookupCacheProvider>
  );
}

function AccessionFormInner({
  subjectId,
  orgId,
  containerRef,
  onCreated,
  ref,
  ...props
}: AccessionFormProps) {
  const subjectInitialied = React.useRef(false);

  const { form, setAccessions } = useAccessionForm();

  if (subjectId && !subjectInitialied.current) {
    subjectInitialied.current = true;
    setAccessions(subjectId);
  }

  return (
    <Form
      ref={ref}
      id="create-accession-form"
      onSubmit={(evt) => {
        evt.preventDefault();
        form.handleSubmit();
      }}
      {...props}
      className={cn("flex flex-col gap-8", props.className)}
    />
  );
}
